import { OperationMode } from '../../core/domain/operationMode'

/**
 * Forma exacta que devuelve el endpoint GET /classification-types
 */
export interface OperationModeApiResponse {
    id: number
    key: string
    description: string
}

/**
 * Traduce la respuesta de la API al modelo de dominio.
 *
 * API:    { id, key, description }
 * Domain: { id, code, name }
 */
export class OperationModeAdapter {
    static toDomain(item: OperationModeApiResponse): OperationMode {
        return {
            id: item.id,
            code: item.key,
            name: item.description,
        }
    }

    static toDomainList(items: OperationModeApiResponse[]): OperationMode[] {
        return items.map((item) => OperationModeAdapter.toDomain(item))
    }
}
